import { DocumentSchema, RequestItemsSchema } from '@liscio/api';

/** A request item whose dependency object is a {@link DocumentSchema}. */
export type ReviewableDocumentItem = RequestItemsSchema & {
  dependency: { object: DocumentSchema } | null;
};

export const filterReviewableDocumentItems = (
  items: RequestItemsSchema[]
): ReviewableDocumentItem[] => {
  return items.filter(
    (item): item is ReviewableDocumentItem =>
      item.item_type === 'reviewable_document'
  );
};
